export type DatePreset = '3m' | '6m' | '12m' | 'thism' | 'lastm';

export const DATE_PRESET_KEYS: readonly DatePreset[] = ['3m', '6m', '12m', 'thism', 'lastm'];
